<style>

h1 {
    margin-bottom: 10px;
}

h3 {
    margin-bottom: 0px;
}

.controls {
    padding-top: 10px;
}

/*Municipal*/
.badge {
    padding: 5px;
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 15px;
    color: white;
    font-size: 12px;
    display: inline-block;
    line-height: 1em;
    background-color: black;
}

.official-tagline {
    color: grey;
    font-size: 12px;
    margin-left: 10px;
}

.rich-content-holder {
    margin-top: 15px;
    margin-bottom: 15px;
}

.search-input {
    width: 350px;
}

#search {
    margin-top: 10px;
}

.search-suggestions {
    position: sticky;
    background-color: white;
    color: rgb(184, 184, 184);
    z-index: 10;
    width: 350px;
    border-radius: 15px;
    overflow: hidden;
    font-size: 14px;
    box-shadow: 0px 2px 4px lightgrey;
}

.search-result {
    cursor: pointer;
    padding: 10px;
}

.search-result:hover {
    background-color: rgb(235, 235, 243);
    color: grey;
}

</style>

<script>
import {push} from './pt-router/Router.svelte'
import {onMount, afterUpdate} from 'svelte'
import FeedView from './FeedView.svelte'
import * as Common from './Common.js'
import Spinner from './Spinner.svelte'

import { getContext } from 'svelte';
const { open } = getContext('simple-modal');
import ShareSheetModal from './Sharing/ShareSheetModal.svelte'

export let tag;
export let side

let feed = []
let showWidget = false
let inProgress = false
let latestTimestamp = Math.floor(Date.now() / 1000)

let scrollTopId = null
let scrollTopValue = null

let searchBox;
$: searchBox && function() {
    console.log("searchBox")
    console.log(searchBox)
    searchBox.focus()
}()

export let selectedAreaID = null
let selectedArea = null;
$: filteredAreas = []
let searchQuery = "";
let areaSelectionOpen = false

let feedURL =
    'tag/' + tag +
    '/recent?seen=' + latestTimestamp +
    (selectedArea ? '&area_id=' + selectedArea.id : '')

let feedID = 
    'tag/' + tag +
    (selectedArea ? '&area_id=' + selectedArea.id : '')

$: tag && updateArea()
let oldId = -1

function updateArea() {
    console.log("updateArea")
    resetFeed()
    ready = false
    if(selectedAreaID) {
        Common.getData('area/' + selectedAreaID)
        .then(data => {
            selectedArea = data
            ready = true
            refereshRecentCommentsAndItems()
        })
        return
    } else {
        selectedArea = null
        ready = true
        refereshRecentCommentsAndItems()
    }
}

afterUpdate(() => {
    if(scrollTopId) {
        setTimeout(() => {
            let elem = document.getElementById(scrollTopId)
            if(elem) {
                elem.scrollIntoView()
                side.scrollTop = scrollTopValue
                scrollTopId = null
            }
        }, 0)
    }
})

let ready = false;
onMount(() => {
    if(selectedAreaID) {
        Common.getData('area/' + selectedAreaID)
        .then(data => {
            selectedArea = data
            ready = true
            refereshRecentCommentsAndItems()
        })
        return
    }
    selectedArea = null
    ready = true
    refereshRecentCommentsAndItems()
})

function refereshRecentCommentsAndItems() {
    if(!ready) {
        return
    }

    feedURL =
    'tag/' + tag +
    '/recent?seen=' + latestTimestamp +
    (selectedArea ? '&area_id=' + selectedArea.id : '')

    feedID = 
    'tag/' + tag +
    (selectedArea ? '&area_id=' + selectedArea.id : '')

    if(feedID==oldId) {
        console.log("feedID==oldID")
        return
    }
    oldId=feedID
    console.log("refereshRecentCommentsAndItems()", tag)
    let cachedFeedInfo = Common.getCachedFeed(feedID)
    if(cachedFeedInfo) {
        resetFeed()
        let info = JSON.parse(cachedFeedInfo)
        console.log("using cached feed for='" + feedID + "'", info)
        feed = info.feed
        latestTimestamp = feed[feed.length-1].data.createtime
        scrollTopId = info.itemId
        scrollTopValue = info.scrollTopValue
        Common.clearCachedFeed(feedID)
    } else {
        console.log("inProgress:", inProgress)
        requestNextFeedItems()
    }

    let parentevent = side.onscroll
    side.onscroll = () => {
        parentevent()
        if((side.scrollHeight - (side.scrollTop + side.clientHeight)) < 800) {
            requestNextFeedItems()
        }
    }
}

function requestNextFeedItems() {
    console.log("requestNextFeedItems()")
    if(inProgress) {
        return
    }
    inProgress = true

    feedURL =
        'tag/' + tag +
        '/recent?seen=' + latestTimestamp +
        (selectedArea ? '&area_id=' + selectedArea.id : '')
    
    Common.getData(feedURL)
    .then(data => {
        feed = feed.concat(data)
        if(feed.length==0) {
            inProgress = false
            return
        }
        latestTimestamp = feed[feed.length-1].data.createtime
        inProgress = false
    })
}

function showShareSheet() {
    open(ShareSheetModal, {
        link: "https://plantogether.city/tag/" + tag + (selectedArea ? '?area_id=' + selectedArea.id : ''),
        shareString: "#" + tag + " on Plan Together"},
        {content: { fontSize: '14px', lineHeight: '1.5em'}});
}

function cancelAreaSelection() {
    areaSelectionOpen = !areaSelectionOpen
    //refereshRecentCommentsAndItems()
    //window.history.replaceState("testing", "#" + tag + " on Plan Together", "/tag/" + tag);
}

let requestPending = false
function areaSearchChange() {
	if(searchQuery.length==0 || requestPending) {
		return
	}
	requestPending = true
	filteredAreas = null

	setTimeout(() => {
		if(searchQuery.length==0) {
			requestPending = false
			return
		}
		Common.getData('areas-search/' + searchQuery)
		.then(data => {
			filteredAreas = data
		})
		requestPending = false
	}, 1000)
}

function resetFeed() {
    feed = []
    showWidget = false
    inProgress = false
    latestTimestamp = Math.floor(Date.now() / 1000)

    let scrollTopId = null
    let scrollTopValue = null

    oldId = -1
}

function selectArea(area) {
    push("/tag/" + tag + "?area_id=" + area.id)
    selectedArea = area
    selectedAreaID = selectedArea.id
    areaSelectionOpen = false
    searchQuery = ""
    resetFeed()
    refereshRecentCommentsAndItems()
    //window.history.replaceState("testing", "#" + tag + " on Plan Together", "/tag/" + tag + "?area_id=" + selectedAreaID);
}

function viewWorldWide() {
    selectedArea = null
    resetFeed()
    searchQuery = ""
    areaSelectionOpen = !areaSelectionOpen
    refereshRecentCommentsAndItems()
    window.history.replaceState("testing", "#" + tag + " on Plan Together", "/tag/" + tag);
}

</script>

<svelte:head>
    <!-- Primary Meta Tags -->
    <title>{"#" + tag + (selectedArea ? " in " + selectedArea.name : "") + " on Plan Together"}</title>
    <meta name="title" content={"#" + tag + (selectedArea ? " in " + selectedArea.name : "") + " on Plan Together"}>
    <meta name="description" content={"Discuss, Plan and Learn about #" + tag + " on a Dynamic, Collaborative Map."}>

    <!-- Open Graph / Facebook -->
    <meta property="og:type" content="website">
    <meta property="og:url" content={"https://plantogether.city/tag/" + tag}>
    <meta property="og:title" content={"#" + tag + (selectedArea ? " in " + selectedArea.name : "") + " on Plan Together"}>
    <meta property="og:description" content={"Discuss, Plan and Learn about #" + tag + " on a Dynamic, Collaborative Map."}>
    <meta property="og:image" content="https://plantogether.city/screenshot_home.png">

    <!-- Twitter -->
    <meta property="twitter:card" content="summary_large_image">
    <meta property="twitter:url" content={"https://plantogether.city/tag/" + tag}>
    <meta property="twitter:title" content={"#" + tag + (selectedArea ? " in " + selectedArea.name : "") + " on Plan Together"}>
    <meta property="twitter:description" content={"Discuss, Plan and Learn about #" + tag + " on a Dynamic, Collaborative Map."}>
    <meta property="twitter:image" content="https://plantogether.city/screenshot_home.png">
</svelte:head>

<div class="top">
    <h1># {tag}</h1>
    <p style="color: grey">
        <i>
            Join this discussion by adding this tag when creating new items.
        </i>
    </p>

    <div class="new-controls">
        <div class="control">
            <div class="control-number" style="color: black">
                <b>
                    {#if selectedArea}
                        Area: {selectedArea.name}
                    {:else}
                        Area: Worldwide
                    {/if}    
                </b>
            </div>
            <div class="control-button" on:click={cancelAreaSelection}>
                {#if areaSelectionOpen}
                    Cancel
                {:else}
                    Change
                {/if}
            </div>
        </div>
        <div class="control-single" on:click={showShareSheet}>Share Tag Feed</div>
    </div>

    {#if areaSelectionOpen}
    <div id="search">
        <input class="search-input" placeholder="Type to Search Areas..." bind:this={searchBox} bind:value={searchQuery} on:input={areaSearchChange}>
        {#if searchQuery.length != 0}
            <div class="search-suggestions">
                {#if filteredAreas === null}
                    <Spinner></Spinner>
                {:else if filteredAreas.length != 0}
                    {#each filteredAreas as area}
                        <div class="search-result" on:click={() => selectArea(area)}>
                            {area.name}, {area.country}
                        </div>
                    {/each}
                {/if}
            </div>
        {/if}
        <br>
        <div class="control-single" on:click={viewWorldWide}>Select Worldwide</div>
    </div>
    {/if}


    <h3>Recent</h3>
</div>
{#if !inProgress && feed.length === 0}
<div>
    <p>
        No items found with this tag.
    </p>
</div>
{:else}
    <FeedView includeNames={true} displayAreaLabels={true} {feed} feedName={feedID} {side}></FeedView>
    {#if inProgress}
        <Spinner></Spinner>
    {/if}
{/if}